export * from './cgu.component';
